import React, { useState } from "react";
import { getActiveSchoolId } from "./activeSchool";
import LuongXeTab from "./LuongXeTab";

// Chức năng riêng "Lương xe": mỗi tháng 1 workbook, mỗi sheet 1 tab (xem LuongXeTab).
const monthLabelOf = (mk) => `Tháng ${Number(mk.slice(5, 7))}/${mk.slice(0, 4)}`;
const monthList = () => {
  const out = []; const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  for (let d = new Date(2026, 7, 1); d <= end; d = new Date(d.getFullYear(), d.getMonth() + 1, 1)) out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  return out.reverse();
};

const HappySchoolLuongXe = () => {
  const schoolId = getActiveSchoolId();
  const months = monthList();
  // Mặc định: tháng trước (lương xe chốt sau khi hết tháng).
  const [mk, setMk] = useState(() => { const d = new Date(); const p = new Date(d.getFullYear(), d.getMonth() - 1, 1); const k = `${p.getFullYear()}-${String(p.getMonth() + 1).padStart(2, "0")}`; return months.includes(k) ? k : months[months.length - 1]; });
  if (!schoolId) return <p style={{ color: "#6b7280" }}>Chưa chọn trường.</p>;
  return (
    <div style={{ padding: "8px 4px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>🚌 Lương xe</h2>
        <select value={mk} onChange={(e) => setMk(e.target.value)} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 14, fontWeight: 600 }}>
          {months.map((m) => <option key={m} value={m}>{monthLabelOf(m)}</option>)}
        </select>
      </div>
      <LuongXeTab key={mk} schoolId={schoolId} monthKey={mk} monthLabel={monthLabelOf(mk)} />
    </div>
  );
};

export default HappySchoolLuongXe;
